import React from 'react';

import MoodleLoader from '../../components/MoodleLoader';

const FreeELearningsMoodleLoader = () => {
  return <MoodleLoader endpoint="/api/moodle/free-e-learnings" />;
};

export default FreeELearningsMoodleLoader;
